import { SvgIcon } from '@progress/kendo-react-common';
import { useNavigate } from 'react-router';
import { ChevronRightOutline } from '../../../../../../icons/icons';
import MarkerText from '../../../../../components/inputs/MarkerText';
import { useSearchContext } from '../../../context/SettingsSearchContext';
import { SettingsElementType } from '../types';

export default function SettingsLinkElement(props: { element: SettingsElementType & { type: 'link' } }) {
    const navigate = useNavigate();
    const context = useSearchContext();
    return (
        <div
            id={props.element.id}
            className="d-flex align-items-center justify-content-between px-3 clickable"
            onClick={() => {
                navigate(props.element.to);
            }}>
            <MarkerText highlight={context.term}>{props.element.name}</MarkerText>
            <SvgIcon icon={ChevronRightOutline} />
        </div>
    );
}
